// lib
import generateLabelFromKeys from '../../lib/generateLabelFromKeys.lib';

const parseAlertType = (type) =>
  generateLabelFromKeys(type.split('_').join(' '));

export default parseAlertType;
